document.addEventListener('DOMContentLoaded', function () {
  const target = document.querySelector('.form__width.is-sticky');
  const wrapper = document.querySelector('.form__wrapper');

  if (!target || !wrapper) return;

  const mobileBreakpoint = 750;

  let originalOffsetTop = target.getBoundingClientRect().top + window.pageYOffset;
  let originalStyles = {
    width: `${target.offsetWidth}px`,
    left: `${target.getBoundingClientRect().left}px`,
  };

  function resetPosition() {
    target.classList.remove('fixed-sticky');
    target.classList.remove('at-bottom');
    target.style.width = '';
    target.style.left = '';
    target.style.transform = '';
    originalOffsetTop = target.getBoundingClientRect().top + window.pageYOffset;
    originalStyles = {
      width: `${target.offsetWidth}px`,
      left: `${target.getBoundingClientRect().left}px`,
    };
  }

  function handleScroll() {
    if (window.innerWidth < mobileBreakpoint) {
      resetPosition();
      return;
    }

    const scrollY = window.scrollY;
    const wrapperRect = wrapper.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const targetHeight = target.offsetHeight;
    const targetBottomY = originalOffsetTop + targetHeight;

    // Activate sticky when the bottom of the element passes the bottom of the screen
    if (targetBottomY - scrollY < viewportHeight && wrapperRect.bottom > viewportHeight) {
      target.classList.add('fixed-sticky');
      target.classList.remove('at-bottom');
      target.style.width = originalStyles.width;
      target.style.left = originalStyles.left;
      target.style.transform = 'translateY(-20px)';
    } else if (wrapperRect.bottom <= viewportHeight) {
      // Deactivate when wrapper bottom passes viewport bottom
      target.classList.remove('fixed-sticky');
      target.classList.add('at-bottom');
      target.style.width = '';
      target.style.left = '';
      target.style.transform = '';
    } else {
      target.classList.remove('fixed-sticky');
      target.classList.remove('at-bottom');
      target.style.width = '';
      target.style.left = '';
      target.style.transform = '';
    }
  }

  handleScroll();

  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', resetPosition);
});
